<template>
    <div class="index">
        22
    </div>
</template>

<script>
import api from '../../api/main'
import wxPay from '../../utils/pay'
import store from '../../store'
import { Dialog,Toast} from 'vant';
import { isPhoneNumber } from '../../utils/index'
import wxOpen from '../../utils/getOpenId'
export default {
    name: 'index', 
    components: {
    },
    data () {
        return {
            
        }
    },
    watch:{
        
    },
    created(){
        
    },
    mounted(){
        this.$route.query
     
        // var ua = window.navigator.userAgent.toLowerCase();
        // if (ua.match(/MicroMessenger/i) == 'micromessenger'){
        //     this.showTip = true;
        // }
        
        // this.is_weixn();
        let that = this;
        if(that.$route.query.description){
            alert(that.$route.query);
            that.weChatPay(that.$route.query.description,that.$route.query.attach,that.$route.query.memberVIPId);
        }
        window.document.addEventListener('message', function(e) {//注册事件 接收数据
            let message = JSON.parse(e.data);//字符串类型
            // console.log('WebView message:',message);
            localStorage.setItem('token',message.token);

            alert(e.data);
            that.weChatPay(message);
        })
    },
    methods:{
        
        async AliPay(){
            let option = {
                "subject": this.vipList[this.selectIndex].memberTime + '会员',
                "device_info": "msmnile",
                "memberVIPId": this.vipList[this.selectIndex].id,
                "memberTime": this.vipList[this.selectIndex].memberTime,
                "payType": 1
            }
            let res = await api.AliPay(option);
            localStorage.setItem('form',res.data.data);
            this.$router.push({name: 'aliPay'});

        },
        async weChatPay(description,attach,memberVIPId){
            let option = {
                "description": description,
                "device_info": "msmnile",
                "attach": attach,
                "memberVIPId": parseFloat(memberVIPId),
                "payType": 1,
            }
            let res = await api.WeChatPay(option);
            // this.payUrl = res.data.data.h5_url
            window.location.replace(res.data.data.h5_url)
        },

        async WeChatInPay(){
            let option = {
                "description": this.vipList[this.selectIndex].memberTime + '会员',
                "device_info": "msmnile",
                "attach": this.vipList[this.selectIndex].memberTime,
                "memberVIPId": this.vipList[this.selectIndex].id,
                "payType": 1,
                // "openid":'ozzl65uAvDwPFOVrxBQ8eyIHs11o',
                "openid":this.openid,
                
                "appid":'wx72d32521134c11ed'
            }
            let res = await api.JssdkUnifiedorder(option);
            wxPay.wxPay(res.data.data)
        },

        // 获取链接的key
        getUrlKey(name){
            return decodeURIComponent((new RegExp('[?|&]'+name+'='+'([^&;]+?)(&|#|;|$)').exec(location.href)||[,""])[1].replace(/\+/g,'%20'))||null;
        },
        // 获取code
        async getCode(){ 
            const userInfo = this.getUrlKey("userInfo");
            // return;
            this.userInfoces = userInfo
            if(userInfo == null || userInfo == ''){
                window.location.href= 'http://47.112.123.229:8058/wxpay/#/WXOAuth/Index?returnUrl=my-server-note'
            }else{
                this.setOpenId(userInfo)
                localStorage.setItem('openid', userInfo)
            }
        },
        // 选择支付方式
        onClick(type){
            this.radio = type;
        },
        onChange(){},
        // 登录
        async login(){
            let res = await api.ACCOUNT_LOGIN({
                phone:this.phone,
                code:this.code
            });
            if(res.data.code == '200'){
                Dialog({message: '登录成功'});
                this.token = res.data.data.token;
                this.userInfo = res.data.data.userInfo;
                localStorage.setItem('token',res.data.data.token);
                localStorage.setItem('userInfo',JSON.stringify(this.userInfo));
                this.queryVIP();
            }else{
                Dialog({message: res.data.msg});
            }

        },
        // 切换账号
        close(){
            Dialog.confirm({
            title: '提示',
            message:
                '是否退出账号',
            })
            .then(() => {
                this.token = '';
                this.userInfo = {};
                localStorage.removeItem('token');
                localStorage.removeItem('userInfo');
            })
            .catch(() => {
            });
            
        },
        submitPay() {
          const data = {
            OrderID:this.id,
            openid:localStorage.getItem('openid')
          }
          api.wxPay(data).then((res) => {
            var dataList = JSON.parse(res.data);
            if (typeof WeixinJSBridge == "undefined"){
              if( document.addEventListener ){
                  document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
              }else if (document.attachEvent){
                  document.attachEvent('WeixinJSBridgeReady', onBridgeReady); 
                  document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
              }
            }else{
              onBridgeReady();
            }
                
            function onBridgeReady(){
              WeixinJSBridge.invoke(
                  'getBrandWCPayRequest', {
                    "appId":dataList.appId,     //公众号名称，由商户传入     
                    "timeStamp":dataList.timeStamp,         //时间戳，自1970年以来的秒数     
                    "nonceStr":dataList.nonceStr, //随机串     
                    "package":dataList.package,     
                    "signType":dataList.signType,         //微信签名方式：     
                    "paySign":dataList.paySign //微信签名 
                  },
                  function(res){
                        var temp =res.err_msg;
                        if(temp.indexOf('ok')>-1){
                        window.location.href = "http://wy.chezhuweishi.com/#/my-index"
                  } 
                  // if(res.err_msg == "get_brand_wcpay_request:ok" ){
                  // // 使用以上方式判断前端返回,微信团队郑重提示：
                  //       //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
                  //       // this.$router.push({name: 'my-server-note'})
                  //     // this.Dialog({message: '订单支付成功，请在服务记录中查看订单'})
                  //     window.location.href = "http://wy.chezhuweishi.com/#/my-index"
                  // } 
              }); 
            }
          }).catch((err)=>{
            

          });
        },

        async captchaButtonClick() {
            if(!isPhoneNumber(this.phone)){
                Toast({message: '注册账号不是手机号!'});
                return;
            }
            if (this.captchaFont != '获取验证码') return
            if (this.phone) {
            if (isPhoneNumber(this.phone)) {
                let res = await api.Send_Code(this.phone);
                if(res.data.code == '200'){
                    this.code = res.data.Msg
                    this.countdown();
                }
            } else {
                
            }
            } else {
                
            }
        },
        // 倒计时
        countdown() {
            this.captchaFont = this.totalTime + '秒'
            this.timer = window.setInterval(() => {
            this.totalTime--
            this.rulesText = '验证码已发送'
            if (this.totalTime !== 0) {
                this.captchaFont = this.totalTime + '秒'
            } else {
                this.cleanTimer()
            }
            }, 1000)
        },
        cleanTimer() {
            window.clearInterval(this.timer)
            this.totalTime = 60
            this.captchaFont = '获取验证码'
            this.rulesText = ''
        },
    }
  
}
</script>

<style lang="scss" scoped>
    
    .line{
        width: 100%;
        height: 8px;
        background-color: #eeeeee;
    }
    .title{
        width: 690px;
        height: 88px;
        margin: 0 auto;
        display: flex;
        align-items: center;
        font-size: 30px;
        color: #e381cb;
        img{
            width: 40px;
            height: 40px;
            margin-right: 20px;
        }
        
    }
    
    .input{
        width: 690px;
        display: flex;
        justify-content: space-between;
        margin: 0 auto;
        margin-bottom: 30px;
        border:0px;
        border-color: #ffffff !important;
        padding-top: 28px;
        color: #333333;
        /deep/.van-cell{
            width: 450px;
            border:1px solid #e381cb;
            padding:15px;
            border-radius: 6px;
        }
        /deep/.van-button {
            height:70px
        }
        .input-code{
            display: flex;
            margin-top: 20px;
            .input-code-l{
                width: 220px;
                margin-right: 26px;
                /deep/.van-cell{
                    width: 220px;
                    flex: auto;
                }
                // /deep/.van-button--normal{
                //     min-width: 200px;
                // }
                
            }
            
            // /deep/.van-button::before{
            //     width: 200px;
            // }
        }
        .input-code-s{
            display: flex;
            justify-content: space-between;
            .codebtn{
                border-color: #ffffff !important;
            }
        }
    }
    .header{
        width: 750px;
        margin: 0 auto;
        display: flex;
        align-items: center;
        font-size: 32px;
        justify-content: space-between;
        padding-right: 30px;
        border-top:2px solid #eeeeee;
        .header-l{
            display: flex;
            align-items: center;
            img{
                width: 120px;
                height: 120px;
                border-radius: 50%;
                margin: 30px;
            }
            .icon{
                width: 97px;
                height: 30px;
                margin-left: 12px;
                border-radius: 0;
            }
        }
        
    }
    .tip{
        width: 690px;
        margin: 0 auto;
        display: flex;
        flex-wrap: wrap;
        .tip-line{
            width: 100%;
            height: 2px;
            background-color: #eeeeee;
        }
        .t-item{
            display: flex;
            align-items: center;
            height: 88px;
            width: 344px;
            font-size: 28px;
            color: #444444;
            span{
                color: #e381cb;
                margin-right: 10px;
            }
        }
        
    }
    .vip-title{
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 30px;
        height: 88px;
        color: #444444;
        .vip-line{
            width: 100px;
            height: 1px;
            background-color: #222222;
            
        }   
        
    }
    .vip-content{
        width: 720px;
        margin: 0 auto;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        .vip-item{
            width: 205px;
            height: 230px;
            border: 1px solid #cccccc;
            margin: 0 13px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            border-radius: 10px;
            margin-bottom: 30px;
            .vip-item1{
                font-size: 36px;
                margin-bottom: 15px;
                color: #444444;
            }
            .vip-item2{
                font-size: 42px;
                color: #e381cb;
                margin-bottom: 15px;
                font-weight: bold;
            }
            .vip-item3{
                font-size: 28px;
                color: #444444;
            }
            .vip-item4{
                font-size: 25px;
                color: #444444;
                text-align: center;
            }
        }
        .vip-item-this{
            background-color: #fdf1fa;
            border: 1px solid #e381cb;
        }
    }
    .pay{
        width: 750px;
        margin: 0 auto;
    }
    .pay-title{
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 30px;
        height: 88px;
        .pay-line{
            width: 100px;
            height: 1px;
            background-color: #222222;
            
        }   
        
    }
    .pay-l{
        display: flex;
        align-items: center;
        font-size: 32px;
        height: 70px;
        img{
            width: 60px;
            height: 60px;
            margin-right: 20px;
        }
    }
    .pay-tip{
        height: 70px;
        font-size: 24px;
        display: flex;
        align-items: center;
        padding-left: 30px;
        span{
            color: #e381cb;
        }
    }
    .btn{
        width: 500px;
        margin: 0 auto;
        padding: 30px;
        /deep/.van-button{
            width: 500px;
            height: 80px;
        }
    }
    .index{
        position:relative
    }
    .wxtip {
        background: rgba(0, 0, 0, 0.8);
        text-align: center;
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        z-index: 100;

        img {
            width: 150px;
            height: 150px;
            position: absolute;
            right: 50px;
            top: 30px;
        }
    }

    .wxtip-txt {
        margin-top: 150px;
        color: #fff;
        font-size: 36px;
        line-height: 80px;
    }
</style>
